import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useCart } from '../Header/CartContext'; // ✅ Import useCart
import { useNavigate } from 'react-router-dom';

interface PaymentPageProps {
  total: number;
  onPaymentSuccess: () => void;
}

const PaymentPage: React.FC<PaymentPageProps> = ({ total, onPaymentSuccess }) => {
  const [paymentMethod, setPaymentMethod] = useState('COD');
  const [loading, setLoading] = useState(false);
  
  // ✅ Get cart functions
  const { cart, removeFromCart, fetchCart } = useCart(); 
  const navigate = useNavigate();

  const handlePlaceOrder = async () => {
    const userString = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (!userString || !token) {
      toast.error("Please login to place an order.");
      return;
    }

    const user = JSON.parse(userString);
    const selectedAddressId = localStorage.getItem("selectedAddress");

    if (!user.id || !selectedAddressId) {
      toast.error("User or Address missing!");
      return;
    }

    setLoading(true);
    try {
      const orderPayload = {
        userId: user.id,
        addressId: selectedAddressId,
        items: cart.map(item => ({
          productName: item.productName,
          price: item.price,
          quantity: item.quantity,
          imageUrl: item.imageUrl
        }))
      };

      await axios.post("https://ayushvatika.com/api/orders/place", orderPayload, {
      // await axios.post("http://localhost:8484/api/orders/place", orderPayload, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      // ✅ Order Success! Now Clear Cart
      // Hum ek-ek karke items remove karenge taaki cart empty ho jaye
      for (const item of cart) {
          await removeFromCart(item.productId);
      }
      await fetchCart(); // Refresh context

      toast.success("Order Placed Successfully!");
      onPaymentSuccess(); 
      navigate('/'); // Redirect to profile
      
    } catch (error: any) {
      console.error("Order failed", error);
      const msg = error.response?.data || "Failed to place order.";
      toast.error(typeof msg === 'string' ? msg : "Order failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
        💳 Choose Payment Method
      </h2>

      <div className="space-y-4 mb-6">
        <label className={`flex items-center p-4 border rounded-lg cursor-pointer transition-all ${paymentMethod === 'COD' ? 'bg-emerald-50 border-emerald-500 ring-1 ring-emerald-500' : 'hover:bg-gray-50'}`}>
          <input 
            type="radio" 
            name="payment" 
            value="COD" 
            checked={paymentMethod === 'COD'} 
            onChange={() => setPaymentMethod('COD')}
            className="w-5 h-5 text-emerald-600 focus:ring-emerald-500 accent-emerald-600"
          />
          <span className="ml-3 font-semibold text-gray-800">Cash on Delivery (COD)</span>
        </label>
        
        <label className="flex items-center p-4 border rounded-lg opacity-60 cursor-not-allowed bg-gray-50">
          <input type="radio" disabled className="w-5 h-5" />
          <span className="ml-3 text-gray-500">UPI / Cards (Coming Soon)</span>
        </label>
      </div>

      <div className="border-t pt-4">
        <p className="text-lg mb-4 text-gray-700">Total Payable: <span className="font-bold text-gray-900">₹{total}</span></p>
        
        <button
          onClick={handlePlaceOrder}
          disabled={loading}
          className={`w-full py-3 rounded-lg font-bold text-lg text-white shadow-lg transition-all transform hover:-translate-y-1 
            ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700'}`}
        >
          {loading 
            ? "Processing..." 
            : paymentMethod === 'COD' 
                ? "Place Order" 
                : `PAY ₹${total}` 
          }
        </button>
      </div>
    </div>
  );
};

export default PaymentPage;